let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("fyAmH")).then(() => parcelRequire('6Zwhu'));